import React from 'react';
import { useCustomer } from '../../Data/Customers';
import { useRound } from '../../Data/Rounds';
import { useQuote } from '../../Data/Quotes';
import { CustomerResult, RoundResult, QuoteResult, PageResult } from './SearchResults';
import recents from './RecentsClass';
import pages from './pages';

const RecentCustomer = ({id, close}) => {
    const {customer, isLoading} = useCustomer(id, false, true);

    if (isLoading || !customer) {
        return null;
    }

    return <CustomerResult customer={customer} close={close} />;
};

const RecentRound = ({id, close}) => {
    const {round, isLoading} = useRound(id, false);

    if (isLoading || !round) {
        return null;
    }

    return <RoundResult round={round} close={close} />;
};

const RecentQuote = ({id, close}) => {
    const {quote, isLoading} = useQuote(id, false);

    if (isLoading || !quote) {
        return null;
    }

    return <QuoteResult quote={quote} close={close} />;
};

const RecentPage = ({id, close}) => {
    const page = pages.find(p => p.to === id);

    if (!page) {
        return null;
    }

    return <PageResult page={page} close={close} />;
};

const RecentItem = ({recent, close}) => {
    const model = recent.model.split('/')[0];

    switch (model) {
        case 'Customers':
            return <RecentCustomer id={recent.id} close={close} />;
        case 'Rounds':
            return <RecentRound id={recent.id} close={close} />;
        case 'Quotes':
            return <RecentQuote id={recent.id} close={close} />;
        case 'App':
            return <RecentPage id={recent.id} close={close} />;
        default:
            return null;
    }
};

const Recents = ({close}) => {
    const recentItems = recents.get();

    if (!recentItems || recentItems.length === 0) {
        return null;
    }

    return <div className="flex flex-col gap-3 py-2">
        <div className="text-sm font-bold text-slate-400 dark:text-slate-500 flex flex-row items-center justify-between">
            Recent
        </div>
        {recentItems.map((recent, index) => (
            <RecentItem key={`${recent.model}-${recent.id}-${index}`} recent={recent} close={close} />
        ))}
    </div>;
};

export default Recents;
